export default __webpack_public_path__ + "static/media/starters.fd2731e5.png";